import { useEffect, useState } from 'react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import News from '../News';
import './style.scss';

function NewsCarousel({ data, language }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }
    window.addEventListener('resize', handleResize)
  });

  return (
    <div className="component--news-carousel">
      <Swiper
        key={data.length}
        modules={[ Navigation, Pagination, Autoplay ]}
        spaceBetween={isMobile ? 12 : 24}
        slidesPerView={isMobile ? 1 : 2}
        loop={data.length >= 3}
        navigation={true}
        pagination={{ clickable: true }}
        autoplay={
          data.length >= 3
            ? {
                delay: 7000,
                disableOnInteraction: false,
              }
            : false
        }
      >
        {data.map((item, index) => {
          return (
            <SwiperSlide key={`news-highlight--${index}`}>
              <News
                isHighlight={true}
                title={language === 'ja' && item.fields.title_ja ? item.fields.title_ja : item.fields.title}
                image={item.fields.image[0].url}
                description={language === 'ja' && item.fields.description_ja ? item.fields.description_ja : item.fields.description}
                link={item.fields.link}
                degree={(index / data.length) * 720}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default NewsCarousel;
